const rgstrRqd = "Registration Required";
const dropInWlcm = "Drop-Ins Welcome!";

// Full details of classes.
export const classDetails = [
  {
    id: 0,
    className: `Pre-Ballet I`,
    description: `Designed for 3-4 year olds. Students are introduced to ballet vocabulary and class etiquette, focusing on the development of coordination, strength, flexibility, and musicality during their early development stages. It is important to us to maintain a creative and accepting learning environment to keep our tiny dancers motivated and engaged in the art of ballet.`,
    requirements: [`Ages 3-4`],
    dropInOrRegs: rgstrRqd,
    imgId: 0,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Saturday`,
        startTime: `9:00 am`,
        endTime: `10:00 am`,
        instructor: `Ms. Mitzy`,
      },
    ],
  },
  {
    id: 1,
    className: `Pre-Ballet II`,
    description: `Designed for 5-6 year olds. Pre-Ballet II is a class designed to introduce the fundamentals of classical ballet technique. The class begins with conditioning, strengthening and stretching exercises to help students use, and isolate, certain muscle groups pertaining to dance. This class will enhance the student’s coordination, balance and flexibility, as well as musicality.`,
    requirements: [`Ages 5-7`],
    dropInOrRegs: rgstrRqd,
    imgId: 1,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Thursday`,
        startTime: `5:30 pm`,
        endTime: `6:30 pm`,
        instructor: `Ms. Melanie`,
      },
      {
        weekDay: `Saturday`,
        startTime: `9:00 am`,
        endTime: `10:00 am`,
        instructor: `Ms. Mitzy`,
      },
    ],
  },
  {
    id: 2,
    className: `Ballet I`,
    description: `Ballet I includes basic barre exercises, as well as center work implementing the study of classical ballet vocabulary. Instruction involves strong concentration on correct body alignment, along with the development of attention span, discipline, and musicality.`,
    requirements: [`Placement by Evaluation`, `Ages 8+`],
    dropInOrRegs: rgstrRqd,
    imgId: 2,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Monday`,
        startTime: `4:30 pm`,
        endTime: `5:30 pm`,
        instructor: `Ms. Anahid`,
      },
      {
        weekDay: `Wednesday`,
        startTime: `4:30 pm`,
        endTime: `5:30 pm`,
        instructor: `Ms. Anahid`,
      },
    ],
  },
  {
    id: 3,
    className: `Ballet II`,
    description: `Ballet II is for students who have studied the basics and are ready to concentrate on developing a broader ballet vocabulary through barre work, center exercises, and across the floor combinations designed to improve coordination, flexibility, endurance, and musicality. This class will strengthen the feet and ankles to prepare the students for pointe shoes, and more advanced technique.`,
    requirements: [
      `Placement by Evaluation`,
      `Students are required to attend a minimum of two ballet technique classes per week.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 3,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Monday`,
        startTime: `4:30 pm`,
        endTime: `5:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
      {
        weekDay: `Wednesday`,
        startTime: `4:30 pm`,
        endTime: `5:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 4,
    className: `Ballet III`,
    description: `Ballet III is an intermediate class designed with focus on classical ballet technique through a professional class progression. We highly recommend students at this level take class at least three times a week for optimal growth. Students will build on their skills and strength, and refine their movement with attention to technique, execution and artistry.`,
    requirements: [
      `Placement by Evaluation`,
      `Students are required to attend a minimum of two ballet technique classes per week.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 4,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Monday`,
        startTime: `5:30 pm`,
        endTime: `7:00 pm`,
        instructor: `Ms. Anahid`,
      },
      {
        weekDay: `Wednesday`,
        startTime: `5:30 pm`,
        endTime: `7:00 pm`,
        instructor: `Ms. Anahid`,
      },
    ],
  },
  {
    id: 5,
    className: `Ballet IV`,
    description: `Ballet IV is an advanced-level class with a required placement class prior to enrollment. Students continue developing advanced technique with a strong focus on musicality, discipline, and professionalism. At this advanced level, students are given extended barre exercises that incorporate increasing demi-pointe work, as well as stretching and strengthening exercises. Classical ballet lines should be well established, and students are introduced to new vocabulary for traveling steps, elevation, and pirouettes. The use of arms and upper back continues to build on the foundation established in the previous level, further refining their expression and fluidity. Students at this level should have a strong grasp of classical ballet vocabulary and can now adequately demonstrate correct use of line and musical performance in their movements.`,
    requirements: [
      `Placement by Evaluation`,
      `Students are required to attend a minimum of three ballet technique classes per week.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 5,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Tuesday`,
        startTime: `5:00 pm`,
        endTime: `6:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
      {
        weekDay: `Thursday`,
        startTime: `5:00 pm`,
        endTime: `6:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 6,
    className: `Ballet V`,
    description: `Ballet V is an advanced-level class with a required placement class prior to enrollment. Students must demonstrate a thorough understanding of all positions, arabesque, & épaulement placement, as well as mastery of pirouette preparation & execution. Proper technique is critical at this level. Students must show no signs of sickling, hip raising, or loss of control over their body, core, & limbs.

    In this class, dancers continue to develop spatial awareness, body orientation, and full-body coordination, with an added focus on fluidity of movement. The curriculum includes advanced steps such as multiple pirouettes, turns in à la seconde, and beating jumps.
    
    Material is taught quickly at this level, and students are expected to pick it up at a fast rate.`,
    requirements: [
      `Placement by Evaluation`,
      `Students are required to attend a minimum of three ballet technique classes per week.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 6,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Monday`,
        startTime: `5:30 pm`,
        endTime: `7:00 pm`,
        instructor: `Mrs. Ailyn`,
      },
      {
        weekDay: `Wednesday`,
        startTime: `5:30 pm`,
        endTime: `7:00 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 7,
    className: `Ballet VI`,
    description: `Ballet VI represents a highly advanced stage of a dancer’s development. At this level, students are expected to possess the technical foundation and artistry necessary for corps de ballet work.

    This class emphasizes refinement and consistency of technique, with a focus on strength, precision, and control. Barre work is performed in socks to further challenge stability, alignment, and articulation of the feet. Center work is completed in ballet shoes, allowing dancers to fully apply their technique in movement.
    
    Dancers continue to build on advanced vocabulary while incorporating more complex combinations, musicality, and performance quality. Additional focus is placed on stamina, versatility, and the ability to execute material with clarity and confidence.
    
    Material is taught at a fast pace, and students are expected to demonstrate strong retention, adaptability, and a high level of discipline.`,
    requirements: [
      `Placement by Evaluation`,
      `Students are required to attend a minimum of four ballet technique classes per week.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 7,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Monday`,
        startTime: `7:00 pm`,
        endTime: `8:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
      {
        weekDay: `Wednesday`,
        startTime: `7:00 pm`,
        endTime: `8:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 8,
    className: `Ballet VII`,
    description: `Ballet VII represents the highest level of training within the program and is intended for pre-professional dancers who exhibit outstanding technique, artistry, and discipline.

    At this level, dancers are expected to execute all movements with a high degree of precision, control, and consistency. Barre work is performed in flat ballet shoes, while center work is completed en pointe, reinforcing strength, balance, and technical clarity at an advanced level.
    
    The curriculum emphasizes the highest level of classical technique while incorporating new elements drawn from modern classical ballet variations and contemporary choreography. This approach ensures dancers are versatile, adaptable, and prepared for a wide range of repertory and choreographic demands.
    
    Dancers continue to refine musicality, performance quality, and stylistic nuance, with a strong focus on artistry and professional-level execution. Material is taught at a fast pace, and students are expected to quickly absorb, retain, and perform complex combinations with confidence and maturity.`,
    requirements: [
      `Placement by Evaluation`,
      `Students are required to attend a minimum of four ballet technique classes per week.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 8,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Tuesday`,
        startTime: `6:30 pm`,
        endTime: `8:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
      {
        weekDay: `Thursday`,
        startTime: `6:30 pm`,
        endTime: `8:30 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 9,
    className: `Pointe I`,
    description: `Pointe I is an invitation-only class for select Ballet III & IV students. This class serves as a preparation for pointe work and requires students to demonstrate very strong ankles, excellent body awareness, core stability, and a solid foundation in basic classical ballet technique. Emphasis is placed on ensuring that students are physically prepared to safely begin pointe work, with a focus on proper alignment, strength, and control to prevent injury.`,
    requirements: [
      `Placement by Evaluation`,
      `Students must take at least 2 classes of ballet technique during the week in order to take class on pointe.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 9,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Friday`,
        startTime: `6:00 pm`,
        endTime: `7:00 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 10,
    className: `Pointe II`,
    description: `Pointe II is designed for students who have successfully completed Pointe I and have demonstrated the necessary strength, technique, and control to advance their pointe work. This class continues to build on the foundation established in Pointe I, focusing on increasing strength, stability, and endurance en pointe. Students will work on more complex combinations at the barre and in center, incorporating elements such as sustained balances, turns, and linking steps.

    A strong emphasis is placed on precision, alignment, and fluidity of movement as students begin to explore more advanced pointe repertoire. In addition, this class prepares students for more demanding choreography, requiring a heightened sense of body awareness, coordination, and musicality. Safety remains a priority as students advance in their technical abilities.`,
    requirements: [
      `Placement by Evaluation`,
      `Students must take at least 2 classes of ballet technique during the week in order to take class on pointe.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 10,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Friday`,
        startTime: `7:00 pm`,
        endTime: `8:00 pm`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 11,
    className: `Teen & Adult Ballet: Beginner`,
    description: `Come enjoy the beauty and grace of classical ballet! This class will cover basic ballet positions, steps and vocabulary with a focus on the student's awareness of proper posture and body alignment. Standing barre work and center floor exercises will be given to enhance coordination, strength, balance and flexibility. Participants will also develop a sense of musical awareness and movement quality. No prior ballet experience necessary.`,
    requirements: [`Open to teens & adults!`],
    dropInOrRegs: dropInWlcm,
    imgId: 11,
    registrationReq: false,
    classTimes: [
      {
        weekDay: `Tuesday`,
        startTime: `7:30 pm`,
        endTime: `8:30 pm`,
        instructor: `Ms. Camila`,
      },
      {
        weekDay: `Thursday`,
        startTime: `7:30 pm`,
        endTime: `8:30 pm`,
        instructor: `Ms. Melanie`,
      },
      {
        weekDay: `Saturday`,
        startTime: `12:00 pm`,
        endTime: `1:30 pm`,
        instructor: `Ms. Melanie`,
      },
    ],
  },
  {
    id: 12,
    className: `Teen & Adult Ballet: Int/Adv`,
    description: `This class is designed for intermediate and advanced ballet dancers. Participants will strengthen their ballet technique aimed to improve alignment and balance, strengthen muscles, and increase flexibility. With quality and knowledgeable teaching, and an encouraging environment, these classes will be a perfect fit for those who aspire to improve their dancing, and artistry!`,
    requirements: [`Open to teens & adults!`],
    dropInOrRegs: dropInWlcm,
    imgId: 12,
    registrationReq: false,
    classTimes: [
      {
        weekDay: `Thursday`,
        startTime: `6:30 pm`,
        endTime: `7:30 pm`,
        instructor: `Ms. Melanie`,
      },
      {
        weekDay: `Saturday`,
        startTime: `11:30 am`,
        endTime: `1:00 pm`,
        instructor: `Ms. Camila`,
      },
    ],
  },
  {
    id: 13,
    className: `Teen & Adult Ballet: All Levels`,
    description: `These class is for all dancers, regardless of any past experience! Our instructors cater to a broad spectrum of students. Whether you become a dedicated student who graduates to pointe work, or you’re content to fly under the radar, each level has it’s own benefits and challenges. No matter what level you’re in, remember, the ultimate goal of adult ballet class is to have fun!`,
    requirements: [`Open to teens & adults!`],
    dropInOrRegs: dropInWlcm,
    imgId: 13,
    registrationReq: false,
    classTimes: [],
  },
  {
    id: 14,
    className: `Flexibility & Conditioning: Teen & Adult`,
    description: `Flexibility classes introduce various techniques of flexibility training as well as techniques that are especially designed to improve your range of movement and mobility. The focus of the class is to stretch and lengthen the muscles of the body, and to strengthen them to be able to better execute ballet technique or simply utilize in one’s own daily routine.`,
    requirements: [`Open to teens & adults!`],
    dropInOrRegs: dropInWlcm,
    imgId: 23,
    registrationReq: false,
    classTimes: [
      {
        weekDay: `Tuesday`,
        startTime: `6:30 pm`,
        endTime: `7:30 pm`,
        instructor: `Ms. Camila`,
      },
      {
        weekDay: `Saturday`,
        startTime: `1:30 pm`,
        endTime: `2:30 pm`,
        instructor: `Ms. Camila`,
      },
    ],
  },
  {
    id: 15,
    className: `Flexibility & Conditioning: Youth`,
    description: `A fun and engaging class designed to help children develop flexibility, strength, and body awareness. Through age-appropriate exercises, kids will improve posture, coordination, and overall physical confidence. Our experienced instructors guide each child safely, combining stretching, core strengthening, and playful movement to promote healthy growth and active habits. Perfect for young movers looking to enhance their agility, balance, and fitness in a supportive environment.`,
    requirements: [`Ages 5+`],
    dropInOrRegs: dropInWlcm,
    imgId: 14,
    registrationReq: false,
    classTimes: [
      {
        weekDay: `Tuesday`,
        startTime: `5:30 pm`,
        endTime: `6:30 pm`,
        instructor: `Ms. Camila`,
      },
    ],
  },
  {
    id: 16,
    className: `Strength for Dancers`,
    description: `This class is designed to build strength, stability, and alignment for dancers of all backgrounds, with a foundation in classical ballet principles. Through focused exercises drawn from ballet, Pilates, and functional training, dancers will develop core control, muscular endurance, and injury-resistant technique. Emphasis is placed on correct placement, joint mobility, and the muscular support needed for both performance and longevity. Ideal for ballet dancers, contemporary movers, and performers seeking a deeper connection between strength and artistry.`,
    requirements: [`All ages`],
    dropInOrRegs: dropInWlcm,
    imgId: 16,
    registrationReq: false,
    classTimes: [
      {
        weekDay: `Saturday`,
        startTime: `10:00 am`,
        endTime: `11:00 am`,
        instructor: `Ms. Camila`,
      },
    ],
  },
  {
    id: 17,
    className: `NBYC: Novice`,
    description: `Nylia Ballet Youth Company class for the Novice division.`,
    requirements: [`Nylia Ballet Youth Company`],
    dropInOrRegs: rgstrRqd,
    imgId: 17,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Saturday`,
        startTime: `9:00 am`,
        endTime: `10:00 am`,
        instructor: `Ms. Melanie`,
      },
    ],
  },
  {
    id: 18,
    className: `NBYC: Jr. Pre-Professional`,
    description: `Nylia Ballet Youth Company class for the Jr. Pre-Professional division.`,
    requirements: [`Nylia Ballet Youth Company`],
    dropInOrRegs: rgstrRqd,
    imgId: 18,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Saturday`,
        startTime: `10:00 am`,
        endTime: `11:30 am`,
        instructor: `Mrs. Ailyn`,
      },
    ],
  },
  {
    id: 19,
    className: `NBC: Apprentice`,
    description: `Nylia Ballet Company class for the Apprentice division.`,
    requirements: [
      `Nylia Ballet Youth Company: Sr. Pre-Professional`,
      `Nylia Ballet Company: Corps de Ballet`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 19,
    registrationReq: true,
    classTimes: [],
  },
  {
    id: 20,
    className: `NBC: Company Class`,
    description: `Nylia Ballet Company class, along with Nylia Ballet Youth Company's Sr. Pre-Professional division.`,
    requirements: [
      `Nylia Ballet Youth Company: Sr. Pre-Professional`,
      `Nylia Ballet Company: Apprentice`,
      `Nylia Ballet Company: Corps de Ballet`,
      `Nylia Ballet Company: Demi-Soloist`,
      `Nylia Ballet Company: Soloist`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 20,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Saturday`,
        startTime: `1:00 pm`,
        endTime: `2:30 pm`,
        instructor: `Ms. Ailyn`,
      },
    ],
  },
  {
    id: 21,
    className: `Contemporary Musical Theater`,
    description: `Our Youth Contemporary Musical Theatre class offers a fun and expressive introduction to performance in a supportive ballet school environment. Blending musical theatre, contemporary movement, and storytelling, this class encourages young dancers to explore their creativity and individuality.
    Students will build confidence, stage presence, and emotional expression through age-appropriate choreography, guided improvisation, and character work. The class focuses on freedom of movement, imagination, and connecting to music in an engaging and uplifting way.
    Perfect for kids who love to move, perform, and express themselves, no prior musical theatre experience needed!`,
    requirements: [
      `Ages 8+`,
      `jazz shoes, half soles or ballet shoes`,
      `Comfortable clothing that allows for full movement`,
      `Hair pulled back and secured away from the face`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 21,
    registrationReq: true,
    classTimes: [
      {
        weekDay: `Saturday`,
        startTime: `11:00 am`,
        endTime: `12:00 pm`,
        instructor: `Ms. Melanie`,
      },
    ],
  },
  {
    id: 22,
    className: `Improv & Movement Exploration`,
    description: `This class invites the dancer to explore movement and learn how to make intentional artistic choices while using their knowledge in dance to incorporate awareness of creative expression through movement while adapting to music and space. Each student will learn to better understand their bodies and practice consistent control of their technique while moving through space.
    `,
    requirements: [
      `Ages 8+`,
      `Socks or barefoot (no shoes required)`,
      `Comfortable clothing that allows for full movement`,
      `Hair pulled back and secured away from the face`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 22,
    registrationReq: true,
    classTimes: [],
  },
  {
    id: 23,
    className: `Pointe III`,
    description: `Pointe III is for students who have progressed beyond Pointe II and are ready for more demanding work en pointe. This class focuses on developing greater stamina, precision, and artistry. Students will work on intricate combinations at the barre and in the center, incorporating more challenging turns, extended balances, and petit allegro movements en pointe.

    The class emphasizes seamless transitions between steps, improving foot articulation and strength, and expanding the range of movement en pointe. Students also begin to focus on performance quality and expression, integrating musicality and dynamics into their pointe work. Pointe III prepares dancers for pre-professional level pointe technique, with attention to both technical and artistic development.`,
    requirements: [
      `Placement by Evaluation`,
      `Students must take at least 2 classes of ballet technique during the week in order to take class on pointe.`,
    ],
    dropInOrRegs: rgstrRqd,
    imgId: 10,
    registrationReq: true,
    classTimes: [
      // {
      //   weekDay: `Friday`,
      //   startTime: `7:35 pm`,
      //   endTime: `8:30 pm`,
      //   instructor: `Mrs. Ailyn`,
      // },
    ],
  },
];
